import { useState, useMemo, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { NEWS_POSTS, type NewsDomain } from '@/data/newsData';
import s from './NewsList.module.scss';

// 뉴스 & 소식 목록(/news) — 미리보기 카드 그리드(대표이미지 uncut) → 클릭 시 상세.
//   차후 DB 연계 가능(지금은 정적). 안전/환경 도메인 탭(디폴트 안전). [[evs-news-architecture]]
//   ?tab=environment 로 진입하면 환경 탭으로 열림(상세 페이지 상단 탭이 여기로 연결, 2026-09-08).
export default function NewsList() {
  const [params] = useSearchParams();
  const tabParam = params.get('tab'); // 문자열 값(객체 params는 매 렌더 새 인스턴스라 의존성으로 부적합)
  const [domain, setDomain] = useState<NewsDomain>(tabParam === 'environment' ? 'environment' : 'safety');
  // ★URL의 ?tab이 '실제로' 바뀔 때만 동기화. params 객체를 의존성으로 쓰면 매 렌더 실행되어
  //   목록 탭 버튼(setDomain)으로 전환한 값을 즉시 URL값으로 되돌리는 버그 발생(2026-09-08 수정).
  useEffect(() => { if (tabParam === 'environment' || tabParam === 'safety') setDomain(tabParam); }, [tabParam]);
  const counts = useMemo(() => ({
    safety: NEWS_POSTS.filter((p) => p.domain === 'safety').length,
    environment: NEWS_POSTS.filter((p) => p.domain === 'environment').length,
  }), []);
  const posts = useMemo(() => NEWS_POSTS.filter((p) => p.domain === domain), [domain]);
  return (
    <main className={s.page}>
      <header className={s.head}>
        <div className={s.inner}>
          {/* [2026-10-11 사용자] 전수 조사에서 뉴스만 브레드크럼 누락 발견 → 추가(고객지원 › 뉴스·소식). 헤더가 solid navy라 인라인 크럼. */}
          <nav className={s.crumb} aria-label="현재 위치">
            <a href="#" onClick={(e) => e.preventDefault()}>HOME</a>
            <span className={s.csep} aria-hidden>›</span>
            <a href="#" onClick={(e) => e.preventDefault()}>고객지원</a>
            <span className={s.csep} aria-hidden>›</span>
            <span className={s.ccur} aria-current="page">뉴스·소식</span>
          </nav>
          <p className={s.eyebrow}><span className={s.bar} /> NEWS &amp; INSIGHTS</p>
          <h1 className={s.title}>뉴스 &amp; 소식</h1>
          <p className={s.desc}>폭염·온열질환 안전관리와 대기환경 IoT 모니터링에 관한 EVS의 최신 소식과 인사이트입니다.</p>
        </div>
      </header>

      <div className={s.inner}>
        {/* 안전/환경 세그먼트 토글 — 디폴트 안전 */}
        <div className={s.tabs} role="tablist" aria-label="뉴스 카테고리">
          <button type="button" role="tab" aria-selected={domain === 'safety'}
            className={`${s.tab} ${domain === 'safety' ? s.on : ''}`} onClick={() => setDomain('safety')}>
            안전 <span>{counts.safety}</span>
          </button>
          <button type="button" role="tab" aria-selected={domain === 'environment'}
            className={`${s.tab} ${s.envTab} ${domain === 'environment' ? s.on : ''}`} onClick={() => setDomain('environment')}>
            환경 <span>{counts.environment}</span>
          </button>
        </div>
        <div className={s.grid}>
          {posts.map((p) => (
            <Link key={p.slug} to={`/news/${p.slug}`} className={s.card}>
              <div className={s.media}>
                {p.cover
                  ? <img src={p.cover} alt={p.title} loading="lazy" />
                  : <div className={s.ph}><i className="ti ti-photo" aria-hidden /></div>}
              </div>
              <span className={`${s.cat} ${p.domain === 'environment' ? s.env : ''}`}>{p.domain === 'safety' ? '안전' : '환경'} · {p.category}</span>
              <h3 className={s.cardTitle}>{p.title}</h3>
              <span className={s.date}>{p.date}</span>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
